import React, { useState } from 'react';
import { ArrowRight, ExternalLink, ShieldCheck, X } from 'lucide-react';

const AssessmentRedirectModal = ({
  session,
  redirectInfo,
  loading,
  error,
  verificationRequired,
  verificationMessage,
  devCode,
  onVerifyEmail,
  onClose,
  onContinue,
}) => {
  const [code, setCode] = useState('');

  return (
    <div className="assessment-redirect-overlay" role="dialog" aria-modal="true" aria-label="Assessment partner redirect">
      <div className="assessment-redirect-panel">
        <button className="platform-close" onClick={onClose} aria-label="Close"><X size={18} /></button>
        <div className="section-label">Start Assessment</div>
        <h2>{verificationRequired ? 'Verify your email to start the assessment.' : 'You will now be redirected to our secure assessment partner platform to complete your test.'}</h2>
        <p>
          {verificationRequired
            ? 'We have sent a verification code to your registered email. Enter it below to unlock assessment access.'
            : 'MindVrik has prepared your assessment session. Your plan and payment status remain saved on MindVrik, while the assessment and report are handled on the partner platform.'}
        </p>

        <div className="assessment-session-box">
          <ShieldCheck size={20} />
          <div>
            <strong>{verificationRequired ? 'Email Verification Required' : session?.sessionId ? 'Session Created' : 'Creating session...'}</strong>
            <span>{verificationRequired ? verificationMessage : session?.sessionId || 'Please wait while MindVrik prepares your assessment session.'}</span>
          </div>
        </div>

        {verificationRequired && (
          <div className="checkout-payment-box">
            <div>
              <h3>Verification Code</h3>
              <p>Enter the 6-digit code sent to your email.</p>
              {devCode && <p><strong>Development code:</strong> {devCode}</p>}
            </div>
            <input value={code} onChange={(event) => setCode(event.target.value)} placeholder="Enter code" style={{ padding: '12px', borderRadius: '12px', border: '1px solid #d7e5e1' }} />
          </div>
        )}

        {redirectInfo?.missingConfig && (
          <div className="checkout-message error">{redirectInfo.message}</div>
        )}
        {error && <div className="checkout-message error">{error}</div>}

        <div className="assessment-redirect-actions">
          <button className="btn-ghost" onClick={onClose}>Cancel</button>
          {verificationRequired ? (
            <button className="btn-primary" onClick={() => onVerifyEmail(code)} disabled={loading || code.trim().length < 4}>
              Verify & Start <ArrowRight size={15} />
            </button>
          ) : (
            <button className="btn-primary" onClick={onContinue} disabled={loading || redirectInfo?.missingConfig || !session}>
              Continue to Partner <ExternalLink size={15} />
            </button>
          )}
        </div>

        <div className="platform-api-note">
          Your assessment report will be available on the partner platform after completion.
        </div>
      </div>
    </div>
  );
};

export default AssessmentRedirectModal;
